import MasterCatalog from 'layouts/masterCatalog';
import React from 'react';

export default function AddStoreProducts() {
  return (
    <MasterCatalog mode='add'/>
  );
}